import { StatementType } from "./index.js";
import { isConcurrentlyValue, isExistsValue, isIfValue, isLeftParentToken, isNewStatement, isNotValue, isNullFilter, isOnValue, isOnlyValue, isSemicolonToken, isStringToken, isUniqueValue, isWhereValue, matchCreateIndex, matchKeyModifiers, matchQualifiedName } from "../helper.js";
import { indexColumnsParser } from "./index.columns.js";
//#region ../schema-sql-parser/dist/parser/statement/create.index.js
function createIndexParser(tokens, $pos) {
	const newStatement = isNewStatement(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isUnique = isUniqueValue(tokens);
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isOn = isOnValue(tokens);
	const isOnly = isOnlyValue(tokens);
	const isConcurrently = isConcurrentlyValue(tokens);
	const isIf = isIfValue(tokens);
	const isNot = isNotValue(tokens);
	const isExists = isExistsValue(tokens);
	const isWhere = isWhereValue(tokens);
	const nullFilter = isNullFilter(tokens);
	const createIndex = matchCreateIndex(tokens);
	const qualifiedName = matchQualifiedName(tokens);
	const keyModifiers = matchKeyModifiers(tokens);
	const isToken = () => $pos.value < tokens.length;
	const readName = () => {
		const span = qualifiedName($pos.value);
		if (!span) return "";
		$pos.value += span;
		return tokens[$pos.value - 1].value;
	};
	const ast = {
		type: StatementType.createIndex,
		name: "",
		unique: isUnique($pos.value + 1),
		tableName: "",
		columns: []
	};
	$pos.value += createIndex($pos.value) || 1;
	if (isConcurrently($pos.value)) $pos.value++;
	if (isIf($pos.value) && isNot($pos.value + 1) && isExists($pos.value + 2)) $pos.value += 3;
	if (!isOn($pos.value)) ast.name = readName();
	while (isToken() && !newStatement($pos.value)) {
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (isOn($pos.value) && !ast.tableName) {
			$pos.value++;
			if (isOnly($pos.value) && isString($pos.value + 1)) $pos.value++;
			ast.tableName = readName();
			if (ast.tableName) {
				$pos.value += keyModifiers($pos.value);
				if (isLeftParent($pos.value)) ast.columns = indexColumnsParser(tokens, $pos);
			}
			continue;
		}
		if (isWhere($pos.value) && ast.unique) ast.unique = nullFilter($pos.value, ast.columns.map(({ name }) => name));
		$pos.value++;
	}
	return ast;
}
//#endregion
export { createIndexParser };
